/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type CheckMCPSlugAvailabilitySecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type CheckMCPSlugAvailabilitySecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type CheckMCPSlugAvailabilitySecurity = {
  option1?: CheckMCPSlugAvailabilitySecurityOption1 | undefined;
  option2?: CheckMCPSlugAvailabilitySecurityOption2 | undefined;
};

export type CheckMCPSlugAvailabilityRequest = {
  /**
   * The slug to check
   */
  slug: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type CheckMCPSlugAvailabilitySecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const CheckMCPSlugAvailabilitySecurityOption1$outboundSchema:
  z.ZodMiniType<
    CheckMCPSlugAvailabilitySecurityOption1$Outbound,
    CheckMCPSlugAvailabilitySecurityOption1
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function checkMCPSlugAvailabilitySecurityOption1ToJSON(
  checkMCPSlugAvailabilitySecurityOption1:
    CheckMCPSlugAvailabilitySecurityOption1,
): string {
  return JSON.stringify(
    CheckMCPSlugAvailabilitySecurityOption1$outboundSchema.parse(
      checkMCPSlugAvailabilitySecurityOption1,
    ),
  );
}

/** @internal */
export type CheckMCPSlugAvailabilitySecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const CheckMCPSlugAvailabilitySecurityOption2$outboundSchema:
  z.ZodMiniType<
    CheckMCPSlugAvailabilitySecurityOption2$Outbound,
    CheckMCPSlugAvailabilitySecurityOption2
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function checkMCPSlugAvailabilitySecurityOption2ToJSON(
  checkMCPSlugAvailabilitySecurityOption2:
    CheckMCPSlugAvailabilitySecurityOption2,
): string {
  return JSON.stringify(
    CheckMCPSlugAvailabilitySecurityOption2$outboundSchema.parse(
      checkMCPSlugAvailabilitySecurityOption2,
    ),
  );
}

/** @internal */
export type CheckMCPSlugAvailabilitySecurity$Outbound = {
  Option1?: CheckMCPSlugAvailabilitySecurityOption1$Outbound | undefined;
  Option2?: CheckMCPSlugAvailabilitySecurityOption2$Outbound | undefined;
};

/** @internal */
export const CheckMCPSlugAvailabilitySecurity$outboundSchema: z.ZodMiniType<
  CheckMCPSlugAvailabilitySecurity$Outbound,
  CheckMCPSlugAvailabilitySecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => CheckMCPSlugAvailabilitySecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => CheckMCPSlugAvailabilitySecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function checkMCPSlugAvailabilitySecurityToJSON(
  checkMCPSlugAvailabilitySecurity: CheckMCPSlugAvailabilitySecurity,
): string {
  return JSON.stringify(
    CheckMCPSlugAvailabilitySecurity$outboundSchema.parse(
      checkMCPSlugAvailabilitySecurity,
    ),
  );
}

/** @internal */
export type CheckMCPSlugAvailabilityRequest$Outbound = {
  slug: string;
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const CheckMCPSlugAvailabilityRequest$outboundSchema: z.ZodMiniType<
  CheckMCPSlugAvailabilityRequest$Outbound,
  CheckMCPSlugAvailabilityRequest
> = z.pipe(
  z.object({
    slug: z.string(),
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
    });
  }),
);

export function checkMCPSlugAvailabilityRequestToJSON(
  checkMCPSlugAvailabilityRequest: CheckMCPSlugAvailabilityRequest,
): string {
  return JSON.stringify(
    CheckMCPSlugAvailabilityRequest$outboundSchema.parse(
      checkMCPSlugAvailabilityRequest,
    ),
  );
}
